export enum RiskProfileStatusTypes {
  Open = 1,
  Blocked = 2,
  Closed = 3,
}
